module.exports = __webpack_public_path__ + "img/zuijia_34.5bb864fc.png";